import React, { useEffect, useState } from 'react';
import api from '../api';

const CATEGORIES = ['genel','ekonomi','spor','teknoloji','kripto','sağlık','dünya','kültür'];
const DEFAULT_FORMAT = '📰 <b>{title}</b>\n\n{summary}\n\n🔗 <a href="{url}">Devamını oku</a>\n\n📡 {source}';

function Badge({ color, children }) {
  const C = {
    green: { bg:'rgba(74,222,128,.15)',  c:'#4ade80' },
    red:   { bg:'rgba(239,68,68,.15)',   c:'#ef4444' },
    blue:  { bg:'rgba(96,165,250,.15)',  c:'#60a5fa' },
    teal:  { bg:'rgba(0,180,180,.15)',   c:'var(--accent)' },
    gray:  { bg:'rgba(100,116,139,.15)', c:'#64748b' },
  };
  const s = C[color] || C.gray;
  return <span style={{ background:s.bg, color:s.c, fontSize:11, fontWeight:700, padding:'2px 8px', borderRadius:20 }}>{children}</span>;
}

const PRESETS = [
  { name:'NTV Gündem',    url:'https://www.ntv.com.tr/gundem.rss',            category:'genel' },
  { name:'TRT Haber',     url:'https://www.trthaber.com/sondakika.rss',       category:'genel' },
  { name:'Sabah',         url:'https://www.sabah.com.tr/rss/anasayfa.xml',    category:'genel' },
  { name:'Hürriyet',      url:'https://www.hurriyet.com.tr/rss/anasayfa',     category:'genel' },
  { name:'CNN Türk',      url:'https://www.cnnturk.com/feed/rss/all/news',    category:'genel' },
  { name:'Milliyet',      url:'https://www.milliyet.com.tr/rss/rssnews/guncel.xml', category:'genel' },
  { name:'Sözcü',         url:'https://www.sozcu.com.tr/rss/anasayfa.xml',    category:'genel' },
  { name:'Haberler.com',  url:'https://www.haberler.com/rss/',                category:'genel' },
  { name:'Dünya Gazetesi',url:'https://www.dunya.com/rss',                   category:'ekonomi' },
  { name:'Kripto Para',   url:'https://kriptopara.com.tr/feed/',              category:'kripto' },
  { name:'CoinDesk',      url:'https://www.coindesk.com/arc/outboundfeeds/rss/', category:'kripto' },
  { name:'Sporx',         url:'https://www.sporx.com/rss/',                  category:'spor' },
  { name:'Webtekno',      url:'https://www.webtekno.com/rss.xml',            category:'teknoloji' },
  { name:'Shiftdelete',   url:'https://shiftdelete.net/feed',                category:'teknoloji' },
];

export default function NewsBot() {
  const [channels, setChannels]   = useState([]);
  const [selCh, setSelCh]         = useState(null);
  const [sources, setSources]     = useState([]);
  const [posts, setPosts]         = useState([]);
  const [tab, setTab]             = useState('sources');
  const [loading, setLoading]     = useState(false);

  const [showChForm, setShowChForm]       = useState(false);
  const [editCh, setEditCh]               = useState(null); // edit modu
  const [showSrcForm, setShowSrcForm]     = useState(false);
  const [showManual, setShowManual]       = useState(false);
  const [rssTestUrl, setRssTestUrl]       = useState('');
  const [rssResult, setRssResult]         = useState(null);
  const [rssLoading, setRssLoading]       = useState(false);

  const emptyChForm = { name:'', channel_id:'', bot_token:'', interval_minutes:30, post_photo:true, footer_text:'', post_format:DEFAULT_FORMAT };
  const [chForm, setChForm]   = useState(emptyChForm);
  const [srcForm, setSrcForm] = useState({ name:'', rss_url:'', category:'genel' });
  const [manualForm, setManualForm] = useState({ text:'', image_url:'' });

  useEffect(() => { loadChannels(); }, []);
  useEffect(() => { if(selCh) { loadSources(selCh.id); loadPosts(selCh.id); } }, [selCh]);

  async function loadChannels() {
    try { const r = await api.get('/news-bot/channels'); setChannels(r.data); } catch(e) {}
  }
  async function loadSources(id) {
    try { const r = await api.get(`/news-bot/channels/${id}/sources`); setSources(r.data); } catch(e) {}
  }
  async function loadPosts(id) {
    try { const r = await api.get(`/news-bot/channels/${id}/posts`, { params:{ limit:30 } }); setPosts(r.data); } catch(e) {}
  }

  async function submitChannel(e) {
    e.preventDefault(); setLoading(true);
    try {
      if (editCh) {
        await api.put(`/news-bot/channels/${editCh.id}`, chForm);
        setEditCh(null);
        if (selCh?.id === editCh.id) setSelCh(p => ({ ...p, ...chForm }));
      } else {
        await api.post('/news-bot/channels', chForm);
      }
      setShowChForm(false); setChForm(emptyChForm);
      loadChannels();
    } catch(ex) { alert('Hata: ' + (ex.response?.data?.error || ex.message)); }
    setLoading(false);
  }

  function openEdit(ch, e) {
    e.stopPropagation();
    setChForm({ name:ch.name, channel_id:ch.channel_id, bot_token:ch.bot_token, interval_minutes:ch.interval_minutes, post_photo:ch.post_photo, footer_text:ch.footer_text||'', post_format:ch.post_format||DEFAULT_FORMAT });
    setEditCh(ch);
    setShowChForm(true);
  }

  async function toggleChannel(ch, e) {
    e.stopPropagation();
    try { const r = await api.post(`/news-bot/channels/${ch.id}/toggle`); loadChannels(); if(selCh?.id===ch.id) setSelCh(p=>({...p,is_active:!p.is_active})); }
    catch(ex) { alert('Hata: ' + ex.message); }
  }

  async function deleteChannel(ch) {
    if (!window.confirm(`"${ch.name}" silinsin mi?`)) return;
    try { await api.delete(`/news-bot/channels/${ch.id}`); if(selCh?.id===ch.id) setSelCh(null); loadChannels(); }
    catch(ex) { alert('Hata: ' + ex.message); }
  }

  async function triggerNow() {
    if (!selCh) return; setLoading(true);
    try {
      const r = await api.post(`/news-bot/channels/${selCh.id}/trigger`);
      const count = r.data?.count ?? 0;
      alert(`✅ Tamamlandı. ${count} yeni haber gönderildi.`);
      setTimeout(() => { loadPosts(selCh.id); loadChannels(); }, 1000);
    } catch(ex) { alert('Hata: ' + (ex.response?.data?.error || ex.message)); }
    setLoading(false);
  }

  async function addSource(e) {
    e.preventDefault();
    try { await api.post(`/news-bot/channels/${selCh.id}/sources`, srcForm); setShowSrcForm(false); setSrcForm({ name:'', rss_url:'', category:'genel' }); loadSources(selCh.id); }
    catch(ex) { alert('Hata: ' + (ex.response?.data?.error || ex.message)); }
  }

  async function addPreset(p) {
    if (sources.some(s => s.rss_url === p.url)) return;
    try { await api.post(`/news-bot/channels/${selCh.id}/sources`, { name:p.name, rss_url:p.url, category:p.category }); loadSources(selCh.id); }
    catch(ex) { alert('Hata: ' + ex.message); }
  }

  async function toggleSource(src) {
    try { await api.put(`/news-bot/sources/${src.id}`, { is_active:!src.is_active }); loadSources(selCh.id); }
    catch(ex) { alert('Hata: ' + ex.message); }
  }

  async function deleteSource(src) {
    if (!window.confirm(`"${src.name}" silinsin mi?`)) return;
    try { await api.delete(`/news-bot/sources/${src.id}`); loadSources(selCh.id); }
    catch(ex) { alert('Hata: ' + ex.message); }
  }

  async function testRss() {
    if (!rssTestUrl.trim()) return;
    setRssLoading(true); setRssResult(null);
    try { const r = await api.post('/news-bot/test-rss', { url: rssTestUrl }); setRssResult(r.data); }
    catch(ex) { alert('RSS hatası: ' + (ex.response?.data?.error || ex.message)); }
    setRssLoading(false);
  }

  async function sendManual(e) {
    e.preventDefault(); setLoading(true);
    try { await api.post(`/news-bot/channels/${selCh.id}/post`, manualForm); alert('✅ Gönderildi!'); setShowManual(false); setManualForm({ text:'', image_url:'' }); loadPosts(selCh.id); }
    catch(ex) { alert('Hata: ' + (ex.response?.data?.error || ex.message)); }
    setLoading(false);
  }

  function timeAgo(ts) {
    if (!ts) return '—';
    const diff = Date.now() - new Date(ts);
    if (diff < 60000) return 'şimdi';
    if (diff < 3600000) return Math.floor(diff/60000) + 'dk';
    if (diff < 86400000) return Math.floor(diff/3600000) + 'sa';
    return Math.floor(diff/86400000) + 'g';
  }

  const inp = { className:'input', style:{ fontSize:13 } };

  return (
    <div className="page-enter">
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:20, flexWrap:'wrap', gap:10 }}>
        <div>
          <h1 style={{ fontSize:22, fontWeight:800, fontFamily:'Plus Jakarta Sans', marginBottom:4 }}>📡 Haber Botu</h1>
          <p style={{ color:'var(--text3)', fontSize:13 }}>RSS kaynaklarından otomatik haber çekip Telegram kanalına paylaş</p>
        </div>
        <button className="btn btn-primary" onClick={() => { setEditCh(null); setChForm(emptyChForm); setShowChForm(true); }}>+ Kanal Ekle</button>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'280px 1fr', gap:16, minHeight:600 }}>

        {/* SOL: Kanal listesi */}
        <div style={{ background:'var(--surface)', border:'1px solid var(--border3)', borderRadius:'var(--radius)', display:'flex', flexDirection:'column', overflow:'hidden' }}>
          <div style={{ padding:'10px 14px', borderBottom:'1px solid var(--border3)', fontSize:12, fontWeight:700, color:'var(--text3)', textTransform:'uppercase', letterSpacing:.5 }}>
            Kanallar ({channels.length})
          </div>
          <div style={{ flex:1, overflowY:'auto' }}>
            {!channels.length && (
              <div style={{ textAlign:'center', padding:30, color:'var(--text3)', fontSize:13 }}>
                <div style={{ fontSize:36, marginBottom:8 }}>📡</div>
                Kanal yok. Ekleyerek başla.
              </div>
            )}
            {channels.map(ch => (
              <div key={ch.id} onClick={() => setSelCh(ch)}
                style={{ padding:'10px 14px', cursor:'pointer', borderBottom:'1px solid var(--border3)', background:selCh?.id===ch.id?'var(--accent-s)':'transparent', borderLeft:selCh?.id===ch.id?'3px solid var(--accent)':'3px solid transparent', transition:'all .1s' }}
                onMouseEnter={e => { if(selCh?.id!==ch.id) e.currentTarget.style.background='var(--surface2)'; }}
                onMouseLeave={e => { if(selCh?.id!==ch.id) e.currentTarget.style.background='transparent'; }}>
                <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:4 }}>
                  <span style={{ fontSize:14, fontWeight:600, color:'var(--text)', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', maxWidth:130 }}>{ch.name}</span>
                  <Badge color={ch.is_active?'green':'gray'}>{ch.is_active?'Aktif':'Pasif'}</Badge>
                </div>
                <div style={{ fontSize:11, color:'var(--text3)', display:'flex', gap:8, flexWrap:'wrap' }}>
                  <span>⏱ {ch.interval_minutes}dk</span>
                  <span>📨 {ch.total_posts}</span>
                  <span>📰 {ch.source_count||0} kaynak</span>
                </div>
                {ch.last_check && <div style={{ fontSize:10, color:'var(--text3)', marginTop:2 }}>Son kontrol: {timeAgo(ch.last_check)}</div>}
                <div style={{ display:'flex', gap:4, marginTop:6 }} onClick={e=>e.stopPropagation()}>
                  <button className="btn btn-ghost btn-sm" style={{ fontSize:11, padding:'2px 8px' }} onClick={e=>openEdit(ch,e)}>✏️ Düzenle</button>
                  <button className="btn btn-ghost btn-sm" style={{ fontSize:11, padding:'2px 8px' }} onClick={e=>toggleChannel(ch,e)}>{ch.is_active?'⏸':'▶️'}</button>
                  <button className="btn btn-danger btn-sm" style={{ fontSize:11, padding:'2px 8px' }} onClick={e=>{e.stopPropagation();deleteChannel(ch);}}>🗑️</button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* SAĞ: Detay */}
        {!selCh ? (
          <div style={{ background:'var(--surface)', border:'1px solid var(--border3)', borderRadius:'var(--radius)', display:'flex', alignItems:'center', justifyContent:'center', color:'var(--text3)' }}>
            <div style={{ textAlign:'center' }}>
              <div style={{ fontSize:48, marginBottom:12, opacity:.3 }}>📡</div>
              <p>Sol taraftan bir kanal seç</p>
            </div>
          </div>
        ) : (
          <div style={{ background:'var(--surface)', border:'1px solid var(--border3)', borderRadius:'var(--radius)', display:'flex', flexDirection:'column' }}>
            {/* Başlık */}
            <div style={{ padding:'12px 18px', borderBottom:'1px solid var(--border3)', display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:8 }}>
              <div>
                <div style={{ fontSize:16, fontWeight:700, color:'var(--text)' }}>{selCh.name}</div>
                <div style={{ fontSize:12, color:'var(--text3)' }}>{selCh.channel_id} · her {selCh.interval_minutes}dk · {selCh.total_posts} haber gönderildi</div>
              </div>
              <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
                <button className="btn btn-teal btn-sm" onClick={triggerNow} disabled={loading}>{loading?'⏳ Çekiyor...':'▶️ Şimdi Çek'}</button>
                <button className="btn btn-ghost btn-sm" onClick={() => setShowManual(true)}>✍️ Manuel Gönder</button>
                <button className="btn btn-ghost btn-sm" onClick={e=>openEdit(selCh,e)}>✏️ Düzenle</button>
              </div>
            </div>

            {/* Sekmeler */}
            <div style={{ display:'flex', borderBottom:'1px solid var(--border3)', flexShrink:0 }}>
              {[['sources','📰 Kaynaklar'],['posts','📋 Paylaşımlar'],['rss','🔍 RSS Test'],['docs','📖 Rehber']].map(([v,l]) => (
                <button key={v} onClick={() => setTab(v)} style={{ padding:'10px 16px', background:'none', border:'none', cursor:'pointer', fontSize:13, fontWeight:600, color:tab===v?'var(--accent)':'var(--text3)', borderBottom:tab===v?'2px solid var(--accent)':'2px solid transparent' }}>{l}</button>
              ))}
            </div>

            <div style={{ flex:1, overflow:'auto', padding:18 }}>

              {/* KAYNAKLAR */}
              {tab === 'sources' && (
                <div>
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:14 }}>
                    <span style={{ fontSize:13, color:'var(--text3)' }}>{sources.length} kaynak</span>
                    <button className="btn btn-primary btn-sm" onClick={() => setShowSrcForm(true)}>+ Manuel Ekle</button>
                  </div>

                  {/* Hazır kaynaklar */}
                  <div style={{ background:'var(--surface2)', borderRadius:'var(--radius-sm)', padding:14, marginBottom:16 }}>
                    <div style={{ fontSize:12, fontWeight:700, color:'var(--text3)', marginBottom:10, textTransform:'uppercase', letterSpacing:.5 }}>⚡ Hazır Kaynaklar</div>
                    <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
                      {PRESETS.map(p => {
                        const added = sources.some(s => s.rss_url === p.url);
                        return (
                          <button key={p.url} onClick={() => addPreset(p)} disabled={added}
                            style={{ padding:'4px 12px', borderRadius:20, border:'1px solid var(--border)', cursor:added?'default':'pointer', fontSize:12, background:added?'var(--accent-s)':'var(--surface)', color:added?'var(--accent)':'var(--text2)', opacity:added?.7:1 }}>
                            {added?'✓ ':''}{p.name}
                          </button>
                        );
                      })}
                    </div>
                  </div>

                  {!sources.length && <div style={{ textAlign:'center', padding:20, color:'var(--text3)', fontSize:13 }}>Henüz kaynak eklenmedi</div>}
                  <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
                    {sources.map(src => (
                      <div key={src.id} style={{ background:'var(--surface2)', border:'1px solid var(--border3)', borderRadius:'var(--radius-sm)', padding:'10px 14px', display:'flex', alignItems:'center', gap:12 }}>
                        <div style={{ flex:1, minWidth:0 }}>
                          <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:3 }}>
                            <span style={{ fontSize:14, fontWeight:600, color:'var(--text)' }}>{src.name}</span>
                            <Badge color={src.is_active?'green':'gray'}>{src.is_active?'Aktif':'Pasif'}</Badge>
                            <Badge color='blue'>{src.category}</Badge>
                          </div>
                          <div style={{ fontSize:11, color:'var(--text3)', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{src.rss_url}</div>
                          {src.last_fetched && <div style={{ fontSize:10, color:'var(--text3)', marginTop:2 }}>Son: {timeAgo(src.last_fetched)} · {src.total_fetched} haber çekildi</div>}
                        </div>
                        <div style={{ display:'flex', gap:6, flexShrink:0 }}>
                          <button className="btn btn-ghost btn-sm" onClick={() => toggleSource(src)}>{src.is_active?'⏸':'▶️'}</button>
                          <button className="btn btn-danger btn-sm" onClick={() => deleteSource(src)}>🗑️</button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* SON PAYLAŞIMLAR */}
              {tab === 'posts' && (
                <div>
                  <div style={{ display:'flex', justifyContent:'space-between', marginBottom:14 }}>
                    <span style={{ fontSize:13, color:'var(--text3)' }}>Son {posts.length} paylaşım</span>
                    <button className="btn btn-ghost btn-sm" onClick={() => loadPosts(selCh.id)}>🔄</button>
                  </div>
                  {!posts.length && <div style={{ textAlign:'center', padding:20, color:'var(--text3)', fontSize:13 }}>Henüz paylaşım yok</div>}
                  <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
                    {posts.map(p => (
                      <div key={p.id} style={{ background:'var(--surface2)', border:'1px solid var(--border3)', borderRadius:'var(--radius-sm)', padding:12, display:'flex', gap:12 }}>
                        {p.image_url && <img src={p.image_url} alt="" style={{ width:56, height:56, objectFit:'cover', borderRadius:6, flexShrink:0 }} onError={e=>e.target.style.display='none'}/>}
                        <div style={{ flex:1, minWidth:0 }}>
                          <div style={{ fontSize:13, fontWeight:600, color:'var(--text)', marginBottom:2, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{p.title||'Başlıksız'}</div>
                          <div style={{ fontSize:11, color:'var(--text3)', marginBottom:4 }}>{p.source_name} · {timeAgo(p.posted_at)}</div>
                          <a href={p.url} target="_blank" rel="noreferrer" style={{ fontSize:11, color:'var(--accent)' }}>🔗 Habere git</a>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* RSS TEST */}
              {tab === 'rss' && (
                <div>
                  <p style={{ fontSize:13, color:'var(--text3)', marginBottom:14 }}>Herhangi bir RSS URL'sini test et, haberler görünüyor mu kontrol et.</p>
                  <div style={{ display:'flex', gap:8, marginBottom:16 }}>
                    <input {...inp} value={rssTestUrl} onChange={e=>setRssTestUrl(e.target.value)} placeholder="https://example.com/rss.xml" style={{ flex:1, fontSize:13 }}/>
                    <button className="btn btn-primary btn-sm" onClick={testRss} disabled={rssLoading}>{rssLoading?'⏳...':'Test Et'}</button>
                  </div>
                  {rssResult !== null && (
                    <div>
                      {rssResult.length === 0
                        ? <div style={{ color:'var(--danger)', fontSize:13 }}>❌ Haber bulunamadı — URL yanlış veya bu site RSS desteklemiyor.</div>
                        : <div>
                            <div style={{ fontSize:12, fontWeight:700, color:'var(--success)', marginBottom:10 }}>✅ {rssResult.length} haber bulundu</div>
                            <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
                              {rssResult.map((item,i) => (
                                <div key={i} style={{ background:'var(--surface2)', border:'1px solid var(--border3)', borderRadius:'var(--radius-sm)', padding:12 }}>
                                  <div style={{ fontSize:13, fontWeight:600, color:'var(--text)', marginBottom:4 }}>{item.title}</div>
                                  {item.summary && <div style={{ fontSize:11, color:'var(--text3)', marginBottom:4 }}>{item.summary.slice(0,120)}...</div>}
                                  <div style={{ display:'flex', gap:12, fontSize:11 }}>
                                    <a href={item.url} target="_blank" rel="noreferrer" style={{ color:'var(--accent)' }}>🔗 Link</a>
                                    {item.image && <span style={{ color:'var(--success)' }}>📷 Görsel var</span>}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                      }
                    </div>
                  )}
                </div>
              )}

              {/* REHBER / DOC */}
              {tab === 'docs' && (
                <div style={{ display:'flex', flexDirection:'column', gap:16, maxWidth:640 }}>
                  <div style={{ background:'var(--surface2)', border:'1px solid var(--border3)', borderRadius:'var(--radius-sm)', padding:16 }}>
                    <div style={{ fontSize:14, fontWeight:700, color:'var(--text)', marginBottom:10 }}>🚀 Kurulum Adımları</div>
                    <ol style={{ fontSize:13, color:'var(--text2)', lineHeight:2, paddingLeft:18, margin:0 }}>
                      <li>BotFather'dan yeni bot oluştur (<code style={{background:'var(--surface3)',padding:'1px 5px',borderRadius:4}}>/newbot</code>) — token'ı kopyala</li>
                      <li>Botu kanalına <b>admin</b> olarak ekle (<b>Mesaj Gönder</b> yetkisi ver)</li>
                      <li>Kanal ID'sini al: @kanaladi şeklinde yaz <b>veya</b> web.telegram.org'da URL'den numeric ID al</li>
                      <li>"Kanal Ekle" butonuna tıkla, bilgileri gir</li>
                      <li>Kaynaklardan hazır sitelerden seç veya RSS URL'si ekle</li>
                      <li>"Şimdi Çek" ile test et</li>
                    </ol>
                  </div>

                  <div style={{ background:'var(--surface2)', border:'1px solid var(--border3)', borderRadius:'var(--radius-sm)', padding:16 }}>
                    <div style={{ fontSize:14, fontWeight:700, color:'var(--text)', marginBottom:10 }}>📝 Mesaj Format Değişkenleri</div>
                    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8 }}>
                      {[
                        ['{title}',   'Haberin başlığı'],
                        ['{summary}', 'Haberin özeti (ilk 350 karakter)'],
                        ['{url}',     'Haberin tam linki'],
                        ['{source}',  'Kaynak adı (örn: NTV)'],
                      ].map(([v,d]) => (
                        <div key={v} style={{ background:'var(--surface3)', borderRadius:6, padding:'8px 12px' }}>
                          <code style={{ color:'var(--accent)', fontSize:13 }}>{v}</code>
                          <div style={{ fontSize:11, color:'var(--text3)', marginTop:3 }}>{d}</div>
                        </div>
                      ))}
                    </div>
                    <div style={{ marginTop:14 }}>
                      <div style={{ fontSize:12, fontWeight:700, color:'var(--text3)', marginBottom:8 }}>Telegram HTML Etiketleri:</div>
                      <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
                        {[['<b>kalın</b>','Kalın'],['<i>italik</i>','İtalik'],['<a href="url">link</a>','Link'],['<code>kod</code>','Kod']].map(([tag,label]) => (
                          <div key={label} style={{ background:'var(--surface3)', borderRadius:6, padding:'4px 10px', fontSize:12 }}>
                            <code style={{ color:'var(--accent)' }}>{tag}</code> <span style={{ color:'var(--text3)' }}>→ {label}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div style={{ marginTop:12, padding:'10px 14px', background:'rgba(0,180,180,.08)', borderRadius:8, border:'1px solid rgba(0,180,180,.2)' }}>
                      <div style={{ fontSize:12, fontWeight:700, color:'var(--accent)', marginBottom:4 }}>Örnek Format:</div>
                      <pre style={{ fontSize:11, color:'var(--text2)', margin:0, whiteSpace:'pre-wrap', fontFamily:'monospace' }}>{`📰 <b>{title}</b>\n\n{summary}\n\n🔗 <a href="{url}">Devamını oku</a>\n\n📡 {source}`}</pre>
                    </div>
                  </div>

                  <div style={{ background:'var(--surface2)', border:'1px solid var(--border3)', borderRadius:'var(--radius-sm)', padding:16 }}>
                    <div style={{ fontSize:14, fontWeight:700, color:'var(--text)', marginBottom:10 }}>⚙️ Ayar Tavsiyeleri</div>
                    <div style={{ display:'flex', flexDirection:'column', gap:8, fontSize:13, color:'var(--text2)' }}>
                      <div style={{ display:'flex', gap:10, alignItems:'flex-start' }}>
                        <span>⏱</span><div><b>Kontrol sıklığı:</b> 15-30 dakika önerilir. Çok sık (5dk altı) Telegram rate limit'e takılabilir.</div>
                      </div>
                      <div style={{ display:'flex', gap:10, alignItems:'flex-start' }}>
                        <span>📷</span><div><b>Fotoğraf seçeneği:</b> Açık olduğunda haberle birlikte görsel gönderilir. Bazı RSS'lerde görsel olmayabilir.</div>
                      </div>
                      <div style={{ display:'flex', gap:10, alignItems:'flex-start' }}>
                        <span>🔁</span><div><b>Tekrar önleme:</b> Sistem aynı URL'yi iki kez göndermez. 48 saatten eski haberler gönderilmez.</div>
                      </div>
                      <div style={{ display:'flex', gap:10, alignItems:'flex-start' }}>
                        <span>📡</span><div><b>Alt metin (footer):</b> Her haberin sonuna kanal adın, yönlendirme linki veya etiket ekleyebilirsin. Örn: <code style={{background:'var(--surface3)',padding:'1px 5px',borderRadius:4}}>👉 @kanaladim</code></div>
                      </div>
                      <div style={{ display:'flex', gap:10, alignItems:'flex-start' }}>
                        <span>✍️</span><div><b>Manuel gönder:</b> Otomatik sistemin dışında, istediğin zaman özel bir mesaj gönderebilirsin.</div>
                      </div>
                    </div>
                  </div>

                  <div style={{ background:'var(--surface2)', border:'1px solid var(--border3)', borderRadius:'var(--radius-sm)', padding:16 }}>
                    <div style={{ fontSize:14, fontWeight:700, color:'var(--text)', marginBottom:10 }}>🔍 Çalışan RSS URL'leri</div>
                    <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
                      {PRESETS.map(p => (
                        <div key={p.url} style={{ display:'flex', alignItems:'center', gap:10, fontSize:12 }}>
                          <span style={{ width:100, fontWeight:600, color:'var(--text2)', flexShrink:0 }}>{p.name}</span>
                          <code style={{ color:'var(--text3)', fontSize:11, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{p.url}</code>
                          <button onClick={() => { setRssTestUrl(p.url); setTab('rss'); }} style={{ background:'none', border:'none', cursor:'pointer', color:'var(--accent)', fontSize:11, flexShrink:0, padding:0 }}>Test →</button>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {/* KANAL EKLE/DÜZENLE MODAL */}
      {showChForm && (
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&setShowChForm(false)}>
          <div className="modal" style={{ maxWidth:520 }}>
            <h3>{editCh ? '✏️ Kanal Düzenle' : '📡 Yeni Kanal Ekle'}</h3>
            <form onSubmit={submitChannel}>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
                <div className="input-group"><label>Kanal Adı</label><input {...inp} value={chForm.name} onChange={e=>setChForm(p=>({...p,name:e.target.value}))} placeholder="Türkiye Haberleri" required/></div>
                <div className="input-group"><label>Telegram Kanal ID</label><input {...inp} value={chForm.channel_id} onChange={e=>setChForm(p=>({...p,channel_id:e.target.value}))} placeholder="@kanal veya -1001234" required/></div>
              </div>
              <div className="input-group"><label>Bot Token</label><input {...inp} value={chForm.bot_token} onChange={e=>setChForm(p=>({...p,bot_token:e.target.value}))} placeholder="1234567890:AAH..." required/></div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
                <div className="input-group"><label>Kontrol Sıklığı (dk)</label><input {...inp} type="number" min="5" max="1440" value={chForm.interval_minutes} onChange={e=>setChForm(p=>({...p,interval_minutes:parseInt(e.target.value)}))} /></div>
                <div className="input-group"><label>Alt Metin (footer)</label><input {...inp} value={chForm.footer_text} onChange={e=>setChForm(p=>({...p,footer_text:e.target.value}))} placeholder="👉 @kanaladim"/></div>
              </div>
              <div className="input-group">
                <label>Mesaj Formatı</label>
                <textarea className="input" value={chForm.post_format} onChange={e=>setChForm(p=>({...p,post_format:e.target.value}))} style={{ minHeight:90, fontSize:12, fontFamily:'monospace' }}/>
                <div style={{ fontSize:11, color:'var(--text3)', marginTop:4 }}>Değişkenler: {'{title}'} {'{summary}'} {'{url}'} {'{source}'}</div>
              </div>
              <div className="input-group" style={{ marginBottom:0 }}>
                <label style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer', fontWeight:'normal' }}>
                  <input type="checkbox" checked={chForm.post_photo} onChange={e=>setChForm(p=>({...p,post_photo:e.target.checked}))}/>
                  Haberlere fotoğraf ekle (varsa)
                </label>
              </div>
              <div style={{ display:'flex', gap:8, justifyContent:'flex-end', marginTop:16 }}>
                <button type="button" className="btn btn-ghost" onClick={()=>{setShowChForm(false);setEditCh(null);}}>İptal</button>
                <button type="submit" className="btn btn-primary" disabled={loading}>{loading?'⏳...':editCh?'💾 Kaydet':'Oluştur'}</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* KAYNAK EKLE MODAL */}
      {showSrcForm && (
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&setShowSrcForm(false)}>
          <div className="modal" style={{ maxWidth:400 }}>
            <h3>📰 RSS Kaynağı Ekle</h3>
            <form onSubmit={addSource}>
              <div className="input-group"><label>Kaynak Adı</label><input {...inp} value={srcForm.name} onChange={e=>setSrcForm(p=>({...p,name:e.target.value}))} placeholder="Örn: NTV" required/></div>
              <div className="input-group"><label>RSS URL</label><input {...inp} value={srcForm.rss_url} onChange={e=>setSrcForm(p=>({...p,rss_url:e.target.value}))} placeholder="https://...rss.xml" required/></div>
              <div className="input-group">
                <label>Kategori</label>
                <select className="input" value={srcForm.category} onChange={e=>setSrcForm(p=>({...p,category:e.target.value}))}>
                  {CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
              </div>
              <div style={{ display:'flex', gap:8, justifyContent:'flex-end' }}>
                <button type="button" className="btn btn-ghost" onClick={()=>setShowSrcForm(false)}>İptal</button>
                <button type="submit" className="btn btn-primary">Ekle</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* MANUEL GÖNDER MODAL */}
      {showManual && (
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&setShowManual(false)}>
          <div className="modal" style={{ maxWidth:480 }}>
            <h3>✍️ Manuel Gönder → {selCh?.name}</h3>
            <form onSubmit={sendManual}>
              <div className="input-group"><label>Görsel URL (opsiyonel)</label><input {...inp} value={manualForm.image_url} onChange={e=>setManualForm(p=>({...p,image_url:e.target.value}))} placeholder="https://...jpg"/></div>
              <div className="input-group">
                <label>Mesaj <span style={{ color:'var(--text3)', fontWeight:'normal' }}>(HTML: &lt;b&gt;, &lt;i&gt;, &lt;a href=""&gt;)</span></label>
                <textarea className="input" value={manualForm.text} onChange={e=>setManualForm(p=>({...p,text:e.target.value}))} style={{ minHeight:140, fontSize:13 }} placeholder="📰 <b>Başlık</b>&#10;&#10;Haberin içeriği..." required/>
              </div>
              <div style={{ display:'flex', gap:8, justifyContent:'flex-end' }}>
                <button type="button" className="btn btn-ghost" onClick={()=>setShowManual(false)}>İptal</button>
                <button type="submit" className="btn btn-primary" disabled={loading}>{loading?'⏳...':'Gönder'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
